<template>
  <potager-link
    v-gtm="{ prefix: gtmPrefix }"
    :aria-label="getLabel"
    :to="getLink"
    target="_blank">
    <component
      :is="getImage"
      :title="getLabel" />
    <slot />
  </potager-link>
</template>

<script>
import { APP_IOS_LINK, APP_ANDROID_LINK } from 'Classes/Constants';

import PotagerPicture from 'UI/PotagerPicture';
import { propsBuilder } from 'UI/Tools';

import IconDownloadGooglePlay from 'Icons/regular/IconDownloadGooglePlay';
import IconDownloadAppStore from 'Icons/regular/IconDownloadAppStore';

export const props = {
  store: {
    type: String,
    default: 'apple',
    values: [
      'google',
      'apple'
    ],
  },
  theme: {
    type: String,
    default: undefined,
    values: [
      undefined,
      'stroke'
    ],
  },
};

export default {

  components: {
    PotagerPicture,
  },

  props: propsBuilder(props),

  computed: {
    getLink() {
      switch (this.store) {
        case 'google':
          return APP_ANDROID_LINK;
        case 'apple':
        default:
          return APP_IOS_LINK;
      }
    },
    getLabel() {
      switch (this.store) {
        case 'google':
          return 'Disponible sur Google Play';
        case 'apple':
        default:
          return 'Télécharger dans l\'App Store';
      }
    },
    getImage() {
      switch (this.store) {
        case 'google':
          return IconDownloadGooglePlay;
        case 'apple':
        default:
          return IconDownloadAppStore;
      }
    },
    gtmPrefix() {
      return `app-${this.store}`;
    },
  },
};
</script>
